import React from "react";
import { CheckCircle } from "@phosphor-icons/react";

const ACRONYMS = new Set(["DRS", "RH", "LH", "USB", "LED", "TV", "AC", "DC", "MPPT", "BMS", "OTM", "AGM", "LCD", "UHF", "GPS", "4WD", "RV", "ABS", "TPMS", "CB", "LPG", "DVD", "HD"]);
const UNITS = [[/AH$/, "Ah"], [/KG$/, "kg"], [/MM$/, "mm"], [/KW$/, "kW"]];

const isShouting = (s) => {
  const letters = s.replace(/[^A-Za-z]/g, "");
  return letters.length > 3 && letters.replace(/[^A-Z]/g, "").length / letters.length > 0.8;
};

function tidyWord(w) {
  const core = w.replace(/[^A-Za-z0-9]/g, "");
  if (!core) return w;
  if (/^X$/i.test(w)) return "×";
  if (ACRONYMS.has(core.toUpperCase()) || core.length === 1) return w.toUpperCase();
  if (/\d/.test(core)) return UNITS.reduce((acc, [re, rep]) => acc.replace(re, rep), w.toUpperCase());
  return w.toLowerCase();
}

export function tidyOption(raw) {
  const s = raw.trim();
  if (!isShouting(s)) return s;
  const out = s.split(/\s+/).map(tidyWord).join(" ");
  return out.charAt(0).toUpperCase() + out.slice(1);
}

export function splitOptions(value) {
  const v = String(value || "");
  const sep = v.includes("+") ? "+" : v.includes(";") ? ";" : null;
  return (sep ? v.split(sep) : [v]).map((x) => x.trim()).filter(Boolean).map(tidyOption);
}

export function OptionsList({ field, value }) {
  const Icon = field.icon;
  const items = splitOptions(value);
  return (
    <div data-testid={`spec-field-${field.key}`} className="bg-[#141414] border border-neutral-800 hover:border-neutral-700 rounded-xl p-5 transition-colors duration-200">
      <div className="flex items-center gap-2 mb-4">
        {Icon && <Icon size={15} className="text-[#73bf44]" weight="duotone" />}
        <span className="font-body text-[0.7rem] font-medium uppercase tracking-[0.12em] text-neutral-400">{field.label}</span>
        <span className="ml-auto text-[0.65rem] text-neutral-600">{items.length} fitted</span>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-3">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2.5 font-body text-sm text-neutral-100 leading-snug" data-testid="additional-option-item">
            <CheckCircle size={17} weight="fill" className="text-[#73bf44] shrink-0 mt-px" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
